// hooks/useExcelSelection.ts
import { useEffect, useRef, useState } from "react";


export default function useExcelSelection(initial: SelectionState = { address: "", text: [], values: [] }) {
  const [selection, setSelection] = useState<SelectionState>(initial);
  const rafRef = useRef<number | null>(null);

  useEffect(() => {
    const onChanged = async () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = requestAnimationFrame(async () => {
        try {
          await Excel.run(async (ctx) => {
            const range = ctx.workbook.getSelectedRange();
            range.load(["address", "text", "values"]);
            await ctx.sync();

            const raw = (range.values as any[][]).map((r) =>
              r.map((v) => (v === undefined ? null : v))
            );
            setSelection({
              address: range.address,
              text: range.text as string[][],
              values: raw,
            });
          });
        } catch (e) {}
      });
    };

    Office.context.document.addHandlerAsync(
      Office.EventType.DocumentSelectionChanged,
      onChanged,
      (res) => {
        if (res.status === Office.AsyncResultStatus.Succeeded) {
          onChanged();
        }
      }
    );

    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      Office.context.document.removeHandlerAsync(Office.EventType.DocumentSelectionChanged, {
        handler: onChanged,
      });
    };
  }, []);

  selection.text = selection.text.filter(
    (x) => !x.every((cell) => cell === null || cell.trim().length == 0)
  );
  selection.values = selection.values.filter(
    (x) =>
      !x.every((cell) => cell === null || (typeof cell === "string" && cell.trim().length == 0))
  );

  return selection;
}
